/* eslint-enable */
/* eslint-enable */

class AnimationLinkBox {
	
	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleLinkBox = this.sectionsContainer.querySelectorAll('.section-link-box');
		
		if (!this.$moduleLinkBox)
			return;
		this.$moduleLinkBoxElements = [];
		this.$moduleLinkBox.forEach(module => {
			this.$moduleLinkBoxElements.push(module.querySelectorAll('.anima'));	
		});
		
		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$moduleLinkBox.forEach((module, index) => {
			gsap.set(module, { opacity: 1});
	        gsap.set(this.$moduleLinkBoxElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });
		});
        
	}

	initAnimate(index) {
		const moduleLinkBox = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleLinkBox[index],
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$moduleLinkBoxElements[index], { clearProps: true });
			}
        });
    
        moduleLinkBox.addLabel('step1');
        moduleLinkBox.to(this.$moduleLinkBox, { opacity: 1, duration: 1 }, 'step1');
		moduleLinkBox.to(this.$moduleLinkBoxElements, { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default AnimationLinkBox;